import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reportes/consolidadoGastos';

import {ConsolidadoGastos} from './Consolidado';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.reporte_consolidado_gastos,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(ConsolidadoGastos);
